import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { HelpDocsService } from './share/help-docs.service';
import { switchMap, map, filter, mergeMap, catchError } from 'rxjs/operators';
import { EMPTY, from, of, throwError } from 'rxjs';
import { FileElement } from './share/file-element.model';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    standalone: false
})
export class HelpComponent implements OnInit, OnDestroy {
  pdfUrl?: string;
  errorMessage?: string;

  constructor(
    private helpDocsService: HelpDocsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.helpDocsService
      .get()
      .pipe(
        filter((helpDocs): helpDocs is FileElement[] => !!helpDocs),
        switchMap(helpDocs => {
          const file = helpDocs.find(hd => !hd.isFolder);
          const directory =
            file && helpDocs.find(hd => hd.isFolder && hd.id === file.parent);
          return directory
            ? this.helpDocsService.getFileBy({
                ...file,
                parent: directory.name,
              })
            : EMPTY;
        }),
        switchMap(blob => {
          if (blob instanceof Blob && blob.type === 'application/pdf') {
            return of(blob);
          }

          return from(blob as string).pipe(
            mergeMap(errorText => throwError(() => new Error(errorText))),
          );
        }),
        map(blob => URL.createObjectURL(blob)),
        catchError(err => {
          this.errorMessage = err.message || 'Failed to load document';
          this.cdr.detectChanges();
          return EMPTY;
        }),
      )
      .subscribe(url => {
        this.pdfUrl = url;
        this.cdr.detectChanges();
      });
  }

  downloadPdf(): void {
    if (!this.pdfUrl) return;

    const link = document.createElement('a');
    link.href = this.pdfUrl;
    link.download = 'help-document.pdf';
    link.click();
  }

  ngOnDestroy(): void {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  }
}
